<template>
  <div>
    <h4 class="my-4">Relação de todas as <strong>Turmas</strong></h4>

    <v-text-field
      v-model="search"
      label="Filtrar a lista abaixo"
      class="mb-4"
      append-icon="mdi-magnify"
    ></v-text-field>

    <v-data-table
      :loading="loading"
      loading-text="Por favor, aguarde o carregamento..."
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      class="elevation-1 mb-4"
      :footer-props="{ itemsPerPageOptions: [15, 25, 35, 55] }"
      @update:options="handleOptionsUpdate"
    >
      <template v-slot:item.count_registrations="{ item }">
        <v-chip :color="getColor(item.registrations.length)" dark>
          {{ item.registrations.length }}
        </v-chip>
      </template>

      <template v-slot:item.launch_notes="{ item }">
        <router-link
          class="btn btn-outline-primary btn-sm"
          :to="{ name: 'team-disciplines', params: { id: item.id } }"
        >
          Lançar Notas
        </router-link>
      </template>

      <template v-slot:item.edit="{ item }">
        <ButtonEdit :to="{ name: 'team-edit', params: { id: item.id } }" />
      </template>

      <template v-slot:item.delete="{ item }">
        <ButtonDelete @delete="() => handlerDelete(item.id, 'teams')" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import api from "@/services";
import ButtonEdit from "@/components/ButtonEdit.vue";
import ButtonDelete from "@/components/ButtonDelete.vue";
import { serialize, handlerDelete } from "@/helpers";

export default {
  name: "TeamList",
  components: {
    ButtonEdit,
    ButtonDelete
  },
  data() {
    return {
      headers: [
        { text: "#", value: "id" },
        { text: "Nome", value: "name" },
        { text: "Matrículados", value: "count_registrations" },
        { text: "Início", value: "start_date" },
        { text: "Término", value: "end_date" },
        { text: "Polo", value: "polo.name" },
        { text: "Grade", value: "grid.name" },
        { text: "Criado", value: "created_at" },
        { text: "Lançar Notas", value: "launch_notes" },
        { text: "Editar", value: "edit" },
        { text: "Remover", value: "delete" },
      ],
      search: "",
      items: [],
      totalItems: 0,
      options: {},
      handlerDelete,
      loading: true,
      searchTimeout: null,
    };
  },
  methods: {
    getColor(count) {
      if (count > 50) return "red";
      else if (count > 25) return "orange";
      else return "green";
    },
    handleOptionsUpdate() {
      this.getTeams();
    },
    async getTeams() {
      this.loading = true;

      const { page = 1, itemsPerPage = 15 } = this.options;

      let query = serialize({
        search: this.search,
      });

      const uri = `/teams?page=${page - 1}&perPage=${itemsPerPage}${query}`;

      try {
        const res = await api.get(uri);
        this.items = res.data.data;
        this.totalItems = res.data.total || res.data.data.length;
      } catch (error) {
        console.error("Erro ao buscar turmas:", error);
        this.items = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    search() {
      // Debounce: aguarda 500ms após o usuário parar de digitar
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        // Volta para a primeira página ao fazer busca
        this.options.page = 1;
        this.getTeams();
      }, 500);
    },
  },
};
</script>

<style scoped></style>
